module.exports = __webpack_public_path__ + "static/media/logo_py.072bdf76.png";